import AddOkrConst from "../constants/addOkr.constants";

export const addNewOkr = item => ({
  type: AddOkrConst.ADD_OKR_NEW,
  value: item
});

export const updateEditedOkr = item => ({
  type: AddOkrConst.EDIT_OKR,
  value: item
});

export const addNewKr = item => ({
  type: AddOkrConst.ADD_KR_NEW,
  value: item
});

export const addUpdateNestedKr = item => ({
  type: AddOkrConst.ADD_UPDATE_NESTED_KR,
  value: item
});

export const deleteNewKr = id => ({
  type: AddOkrConst.DELETE_KR,
  ids: id
});

export const editNewKr = (id, item) => ({
  type: AddOkrConst.EDIT_INLINE_KR,
  krIrd: id,
  value: item
});

export const updateGoalName = (id, goal) => ({
  type: AddOkrConst.UPDATE_GOAL_NAME,
  goalId: id,
  name: goal
});

export const reorderMetrics = items => ({
  type: AddOkrConst.REORDER_METRICS,
  items
});

export const updateExtApp = (item, type = null) => ({
  type: AddOkrConst.UPDATE_EXT_APP,
  value: type ? { item, type } : item
});

export const updateKrWeight = item => ({
  type: AddOkrConst.UPDATE_KR_WEIGHT,
  items: item
});

export const updateKrName = (id, krname) => ({
  type: AddOkrConst.UPDATE_METRIC_NAME,
  krId: id,
  name: krname
});

export const updateIsKrMultiper = () => ({
  type: AddOkrConst.UPDATE_GOAL_ISKRMULTIPER
});

export const updatePermissionsInMetric = teamPermission => {
  return {
    type: AddOkrConst.UPDATE_PERMISSIONS_IN_METRIC,
    teamPermission
  };
};

export const updateClusterData = data => {
  return {
    type: AddOkrConst.UPDATE_CLUSTER_DATA,
    data
  };
}

export const updateClusterDataForIndividualItem = data => {
  return {
    type: AddOkrConst.UPDATE_CLUSTER_DATA_FOR_ITEM,
    data
  };
}